export default "/images/circle_not_closed_active.svg?801a56446d0e828e79c7b62c19a1a26c";